
import { Box, Typography } from '@mui/material';
import { Alarm } from '@mui/icons-material';
import { ActionItemStatus } from '@uplift/api';
import { useCurrentuser } from '@uplift/contexts';
import { L10nHTML, useL10n } from '@uplift/hooks';
import { useProviderScheduleQuery } from '@uplift/queries';
import { LightChip, LinkDashboardActionItem } from '@uplift/ui-v2';

import { getChipColor } from '../../helpers';
import { useSharedStyles } from '../../styles';

export type AddMatchingAvailabilityProps = {
  status: ActionItemStatus;
};

export const AddMatchingAvailability: React.VFC<AddMatchingAvailabilityProps> = ({ status }) => {
  const l10n = useL10n();
  const { classes: sharedClasses } = useSharedStyles();
  const user = useCurrentuser();

  const { data } = useProviderScheduleQuery(user?.id);

  if (status === ActionItemStatus.todo) {
    return (
      <LinkDashboardActionItem
        title={l10n.dashboard.actionItems.addMatchingAvailability.title}
        body={l10n.dashboard.actionItems.addMatchingAvailability.subtitle}
        bodyClassName={sharedClasses.actionItemSubtitle}
        color="warning"
        icon={<Alarm />}
        link="/schedule"
        actionText={l10n.providerSettings.onboarding.addHours}
      />
    );
  }

  return (
    <Box className={sharedClasses.progressSummaryStepWithChip}>
      <Box display="flex" flexDirection="column">
        <Typography variant="h5">{l10n.providerSettings.onboarding.matchingAvailability}</Typography>
        {data && (
          <L10nHTML variant="body2" color="textPrimary">{l10n.providerSettings.onboarding.providerAvailabilityData(data?.idealCaseload || 0, data?.availabilityTotalHours || 0)}</L10nHTML>
        )}
      </Box>
      <LightChip label={l10n.dashboard.actionItems.status[status]} color={getChipColor(status)} size="small" />
    </Box>
  );
};
